import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-emailing',
  templateUrl: './emailing.component.html',
  styleUrls: ['./emailing.component.scss']
})
export class EmailingComponent implements OnInit {

  filtroEstado: any;
  datosEmails: any;

  itemsEstados: any = [
    { name: 'Estado 1', id: 'estado1' },
    { name: 'Estado 2', id: 'estado2' }
  ];

  columns = [
    { name: 'Nombre', prop: 'nombre' },
    { name: 'Correo', prop: 'email' },
  ];

  constructor() { }

  ngOnInit(): void {
    this.getEmailsData();
  }

  changeFilterState(event: any) {
    console.log('event: ', event);
  }

  getEmailsData() {
    //Llamar rest y cargar datos

    this.datosEmails = [
      { nombre: 'Test 1', email: 'test1@test.com', fechaFiltro1: '01/01/2024', fechaFiltro2: '30/12/2024', deliveryStatus: 'sent' },
      { nombre: 'Test 2', email: 'test2@test.com', fechaFiltro1: '01/01/2024', fechaFiltro2: '30/12/2024', deliveryStatus: 'pending' },
      { nombre: 'Test 3', email: 'test3@test.com', fechaFiltro1: '01/01/2024', fechaFiltro2: '30/12/2024', deliveryStatus: 'pending' },
      { nombre: 'Test 4', email: 'test4@test.com', fechaFiltro1: '01/01/2024', fechaFiltro2: '30/12/2024', deliveryStatus: 'pending' },
      { nombre: 'Test 5', email: 'test5@test.com', fechaFiltro1: '01/01/2024', fechaFiltro2: '30/12/2024', deliveryStatus: 'sent' },
    ]
  }

}
